import Polyglot from 'node-polyglot';
import { fi, en, sv } from './translations';
import { SupportedLanguage } from './languageUtils';

const translations = {
  fi,
  en,
  sv,
} as const;

/**
 * Get a translation for a key in the current language
 * @param key The translation key
 * @param options Optional interpolation options
 * @returns The translated string
 */
export const translate = (
  key: string,
  language: SupportedLanguage,
  options?: Polyglot.InterpolationOptions
): string => {
  const messages = translations[language];

  const polyglot = new Polyglot({
    locale: language,
    phrases: messages as Record<string, unknown>,
    allowMissing: true,
    onMissingKey: (missingKey) => `[${missingKey}]`,
  });

  return polyglot.t(key, options);
};
